<template>
    <div>
        <div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblOcorrenciasInternas"
                :itens="contrato.ocorrenciasInternas"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
            </app-tabela>
        </div>
    </div>
</template>

<script>
export default {
    components: {},

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            erros: [],
            campos: [
                {
                    key: 'dtOcorrencia',
                    label: 'Data da Ocorrência',
                    sortable: true,
                    type: 'datetime'
                },
                {
                    key: 'usrLogin',
                    label: 'Usuário',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ocorrencia',
                    label: 'Ocorrência',
                    filterable: true
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {},

    created() {},

    computed: {},

    watch: {}
}
</script>
